module.exports = __webpack_public_path__ + "media/images/icon__email-92845f5f60ab7f9dec164339631418ef.png";